import Cookies from 'js-cookie'
import axios from 'axios'
import { getTurnstileToken, isTurnstileEnabledForProduct } from '@utils/turnstile/turnstile'
import { callWebviewHandler, WebViewActions } from '@utils/webview'
import { AutoProduct } from 'src/enums/AutoProduct'

const AUTO_PROPOSAL_TIMEOUT_MS = 6000
const CAR_PROPOSAL_TIMEOUT_MS = 15000
type TurnstileConfig = Parameters<typeof getTurnstileToken>[0]

const getJourneyRedirect = async (
  regNo: string,
  vehicleType: AutoProduct,
  proposalApiUrl: string,
  setIsFetching: Function,
  setShowIllogicalFlowModal: Function,
  setProposalAPIResponse: Function,
  turnstileConfig?: TurnstileConfig
) => {
  setIsFetching(true)
  const isCarProposal = vehicleType === AutoProduct.Car
  const shouldValidateTurnstile = isTurnstileEnabledForProduct(turnstileConfig, vehicleType)

  const goToProposal = pid => {
    let appendUrl = ''
    if (window?.location?.search) {
      appendUrl = `${window.location.search}&proposal_id=${pid}`
    } else {
      appendUrl = `?proposal_id=${pid}`
    }
    const urlToRedirect =
      vehicleType === AutoProduct.Car
        ? `/car-journey/nsr${appendUrl}&lpSource=/n`
        : `/bike-journey/nsr${appendUrl}&lpSource=/n`

    // cookie('webview') will be android/ios in case of App, call js interface in that case
    if (Cookies.get('webview')) {
      callWebviewHandler({
        url: urlToRedirect,
        action: WebViewActions.OPEN_WEBVIEW,
      })
    } else window.location.href = urlToRedirect
  }

  const illogicalFLowConst = [
    'ILLOGICAL_FLOW_POLICY_EXISTS',
    'ILLOGICAL_FLOW_PAYMENT_DONE',
    'ILLOGICAL_FLOW_POLICY_EXPIRED_RENEWAL_DUE',
  ]

  let turnstileToken: string | null = null
  if (shouldValidateTurnstile && turnstileConfig) {
    turnstileToken = await getTurnstileToken(turnstileConfig)
  }

  await axios
    .request({
      method: 'post',
      url: proposalApiUrl,
      headers: {
        'X-Landing-URL': window?.location?.href || '/',
        'X-Landing-Path': '/',
        'x-app-name': 'frontend-seo',
        ...(turnstileToken ? { 'x-turnstile-token': turnstileToken } : {}),
      },
      data: {
        registration_number: regNo,
        origin: vehicleType === AutoProduct.Car ? 'acko' : 'acko_bike',
        product: vehicleType === AutoProduct.Car ? 'car' : 'bike',
        is_new: false,
      },
      timeout: isCarProposal ? CAR_PROPOSAL_TIMEOUT_MS : AUTO_PROPOSAL_TIMEOUT_MS,
    })
    .then(res => {
      if (res.data?.error_code) {
        // check illogical flow
        const isIllogicalFlow = illogicalFLowConst.filter(key => key === res.data?.error_code).length > 0

        if (isIllogicalFlow) {
          setShowIllogicalFlowModal(true)
        }
      } else {
        // ekey is the proposal id
        res.data.ekey && goToProposal(res.data.ekey)
      }
    })
    .catch(error => {
      const err = JSON.stringify(error?.request?.response).toUpperCase()
      if (err.includes('MODEL_UNSERVICEABLE')) {
        setProposalAPIResponse({
          error_code: 'MODEL_UNSERVICEABLE',
          error_context: {
            user_logged_in: false,
            last_digits: '',
            redirect_url: null,
            vehicle_type: vehicleType,
          },
        })
        setShowIllogicalFlowModal(true)
      }
    })
    .finally(() => {
      setIsFetching(false)
    })
}

export default getJourneyRedirect
